<template>
  <base-info-card title="Produk">
    <a
      v-for="product in products"
      :key="product.web_product_id"
      class="mb-2 white--text body-1 d-block text-none"
      @click="Detail(product.web_product_id)"
      v-html="`&bull; ${product.web_product_name}`"
    />
    <v-snackbar
        v-model="snackbar.value"
      >
        {{ snackbar.text }}
        <template v-slot:action="{ attrs }">
        <v-btn
          color="fourth"
          text
          v-bind="attrs"
          @click="snackbar.value = false"
        >
          Close
        </v-btn>
      </template>
      </v-snackbar>
  </base-info-card>
</template>

<script>
  export default {
    name: 'ProductFeatures',

    data: () => ({
      products: [],
      snackbar: {
        value: false,
        text: ''
      }
    }),
    created () {
      this.List()
    },
    methods: {
      List () {
        let formdata = {
              web_product_actived: 'Y',
              limit: '6',
              order_by: 'web_product_sort',
              order_type: 'ASC',
        }
        let param      = this.$functions.ParamPOST(formdata)
        this.$axios.post(this.$functions.UrlPOST('apiWebProductList'),param,{
        headers: {
            'Content-Type': 'text/plain; charset=ISO-8859-1'
        }
        })
        .then(response => {
            let data = response.data
            if (data.length > 0) {
              if (data[0].feedback === 'Y') {
                this.products = data
              } else {
                this.snackbar.value = true
                this.snackbar.text  = data[0].feedback
              }
            } else {
              this.products = []
            }
        })
        .catch(e => {
            this.snackbar.value = true
            this.snackbar.text  = e
        })
      },
      Detail (url) {
        this.$router.push({name: 'produk-detail', params: { url: url }})
      },
    }
  }
</script>